const getServiceAPIUrl = (rootState) => rootState.ws.config.service.common['ws-api'].url;

export default getServiceAPIUrl;
